export default __webpack_public_path__ + "0a6299fe8a627a6dde608b7a81545af6.wav";